import { useCallback, useEffect, useRef } from 'react';
import { DEFAULT_STATUS, EMPTY_FILTER, KPI_KEYS, PRESET_KEYS } from './constants';

const parseArrayParam = (value) => {
  if (!value) return null;
  return value.split(',').map((s) => s.trim()).filter(Boolean);
};

export const parseNsirMapaSearch = (search) => {
  const params = new URLSearchParams(search);
  const kpi = params.get('kpi');
  const preset = params.get('preset');

  const filter = { ...EMPTY_FILTER };

  const status = parseArrayParam(params.get('status'));
  if (status?.length) filter.status = status;

  const malha = parseArrayParam(params.get('malha'));
  if (malha?.length) filter.malhaId = malha;

  const municipio = parseArrayParam(params.get('municipio'));
  if (municipio?.length) filter.municipioIbge = municipio;

  const validKpi = kpi && Object.values(KPI_KEYS).includes(kpi) ? kpi : null;
  const validPreset = preset && Object.values(PRESET_KEYS).includes(preset) ? preset : null;

  return {
    filter,
    activeKpi: validKpi,
    activePreset: validPreset,
  };
};

export const buildNsirMapaSearch = ({ filter, activeKpi, activePreset }) => {
  const params = new URLSearchParams();

  if (activeKpi) params.set('kpi', activeKpi);
  if (activePreset) params.set('preset', activePreset);

  if (filter?.status?.length && JSON.stringify(filter.status) !== JSON.stringify(DEFAULT_STATUS)) {
    params.set('status', filter.status.join(','));
  }
  if (filter?.malhaId?.length) {
    params.set('malha', filter.malhaId.join(','));
  }
  if (filter?.municipioIbge?.length) {
    params.set('municipio', filter.municipioIbge.join(','));
  }

  return params.toString();
};

export const useNsirMapaUrlState = ({
  history,
  location,
  localFilter,
  activeKpi,
  activePreset,
  onExternalUrlChange,
}) => {
  const skipSyncRef = useRef(false);
  const isFirstSync = useRef(true);
  const isFirstRead = useRef(true);

  const syncUrl = useCallback(
    (state, { replace = true } = {}) => {
      const search = buildNsirMapaSearch(state);
      const pathname = location.pathname;
      const nextUrl = search ? `${pathname}?${search}` : pathname;
      const currentUrl = location.search ? `${pathname}${location.search}` : pathname;
      if (nextUrl === currentUrl) return;

      skipSyncRef.current = true;
      if (replace) {
        history.replace(nextUrl);
      } else {
        history.push(nextUrl);
      }
    },
    [history, location.pathname, location.search],
  );

  useEffect(() => {
    if (isFirstSync.current) {
      isFirstSync.current = false;
      return;
    }
    syncUrl({ filter: localFilter, activeKpi, activePreset });
  }, [localFilter, activeKpi, activePreset, syncUrl]);

  useEffect(() => {
    if (isFirstRead.current) {
      isFirstRead.current = false;
      return;
    }
    if (skipSyncRef.current) {
      skipSyncRef.current = false;
      return;
    }
    onExternalUrlChange?.(parseNsirMapaSearch(location.search));
  }, [location.search, onExternalUrlChange]);
};
